import { DeploymentSelectionView } from "@/features/deployment-selection/ui/deployment-selection-view";

export function DeploymentsRoute() {
  return <DeploymentSelectionView />;
}
